import React from "react";

function Reactions() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="35"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 512 512"
    >
      <path
        fill="#ffdcd0"
        d="M508.425 265.396l-7.619 112.296-482.603-4.741L0 327.521v-65.975c0-3.31 2.771-6 6.181-6h472.853l23.21 3.85c3.42 0 6.181 2.69 6.181 6z"
        data-original="#ffdcd0"
      ></path>
      <g fill="#ffc7b6">
        <ellipse
          cx="457.578"
          cy="291.063"
          data-original="#ffc7b6"
          rx="7.726"
          ry="7.5"
        ></ellipse>
        <ellipse
          cx="395.755"
          cy="291.063"
          data-original="#ffc7b6"
          rx="7.726"
          ry="7.5"
        ></ellipse>
        <ellipse
          cx="426.669"
          cy="320.898"
          data-original="#ffc7b6"
          rx="7.726"
          ry="7.5"
        ></ellipse>
        <ellipse
          cx="116.239"
          cy="291.198"
          data-original="#ffc7b6"
          rx="7.726"
          ry="7.5"
        ></ellipse>
        <ellipse
          cx="170.663"
          cy="298.459"
          data-original="#ffc7b6"
          rx="7.726"
          ry="7.5"
        ></ellipse>
        <ellipse
          cx="341.326"
          cy="298.459"
          data-original="#ffc7b6"
          rx="7.726"
          ry="7.5"
        ></ellipse>
        <ellipse
          cx="85.331"
          cy="320.898"
          data-original="#ffc7b6"
          rx="7.726"
          ry="7.5"
        ></ellipse>
        <ellipse
          cx="54.422"
          cy="291.198"
          data-original="#ffc7b6"
          rx="7.726"
          ry="7.5"
        ></ellipse>
      </g>
      <path
        fill="#ffb5a5"
        d="M505.324 490.11c0 3.31-2.771 6-6.181 6l-42.929 5.44H6.181c-3.41 0-6.181-2.69-6.181-6v-71.169l18.203-51.43 477.314 13.22z"
        data-original="#ffb5a5"
      ></path>
      <path
        fill="#ffc7b6"
        d="M512 327.521v-65.975c0-3.31-2.771-6-6.181-6h-26.785v122.146h21.772z"
        data-original="#ffc7b6"
      ></path>
      <path
        fill="#f9a791"
        d="M500.806 377.692h-21.772v94.743c0 16.08-13.429 29.116-29.995 29.116h56.779c3.414 0 6.181-2.686 6.181-6v-71.169l-11.717-44.345z"
        data-original="#f9a791"
      ></path>
      <path
        fill="#fe93bb"
        d="M426.663 356.116c-42.669 0-42.669-28.597-85.337-28.597-42.667 0-42.667 28.597-85.333 28.597-42.665 0-42.665-28.597-85.33-28.597-42.666 0-42.666 28.597-85.332 28.597-42.665 0-42.665-28.597-85.331-28.597v30.73l3.808 15L0 388.25v36.135c42.665 0 42.665 28.597 85.331 28.597s42.666-28.597 85.332-28.597c42.665 0 42.665 28.597 85.33 28.597 42.666 0 42.666-28.597 85.333-28.597 42.668 0 42.668 28.597 85.337 28.597 34.012 0 40.913-18.17 63.924-25.543v-96.865c-23.011 7.372-29.912 25.542-63.924 25.542z"
        data-original="#fe93bb"
      ></path>
      <path
        fill="#fe76a8"
        d="M512 327.521v30.729l-3.575 16.948L512 388.25v36.131c-15.051 0-24.786 3.56-32.966 8.17v-96.86c8.18-4.61 17.915-8.17 32.966-8.17z"
        data-original="#fe76a8"
      ></path>
      <g fill="#f6f0f7">
        <ellipse
          cx="256"
          cy="404.549"
          data-original="#f6f0f7"
          rx="20.604"
          ry="20"
        ></ellipse>
        <ellipse
          cx="85.331"
          cy="404.549"
          data-original="#f6f0f7"
          rx="20.604"
          ry="20"
        ></ellipse>
        <ellipse
          cx="426.663"
          cy="404.549"
          data-original="#f6f0f7"
          rx="20.604"
          ry="20"
        ></ellipse>
        <ellipse
          cx="170.663"
          cy="372.952"
          data-original="#f6f0f7"
          rx="15.453"
          ry="15"
        ></ellipse>
        <ellipse
          cx="341.326"
          cy="372.952"
          data-original="#f6f0f7"
          rx="15.453"
          ry="15"
        ></ellipse>
      </g>
      <path
        fill="#ece6ed"
        d="M512 358.25v30c-8.53 0-15.453-6.71-15.453-15 0-8.28 6.923-15 15.453-15z"
        data-original="#ece6ed"
      ></path>
      <path
        fill="#f6f0f7"
        d="M15.453 373.25c0 8.29-6.923 15-15.453 15v-30c8.53 0 15.453 6.72 15.453 15z"
        data-original="#f6f0f7"
      ></path>
      <path
        fill="#98d5b9"
        d="M366.865 66.392l-2.447 102.923c0 44.74-18.562 87.977-54.776 114.248l-43.637 31.331a18.112 18.112 0 01-21.271-.001l-41.257-28.831c-4.98-3.613-16.047-9.552-16.047-9.552a139.661 139.661 0 01-43.556-101.337V65.234a3.005 3.005 0 012.994-2.999c52.694-.287 84.498-8.193 107.603-21.758a3.012 3.012 0 013.058 0c20.558 12.07 47.996 19.664 90.921 21.392 4.673 1.42 9.611 1.491 15.421 1.523a3.006 3.006 0 012.994 3z"
        data-original="#98d5b9"
      ></path>
      <path
        fill="#7acaa6"
        d="M368.13 65.23v109.94c0 44.74-21.44 86.77-57.65 113.04l-43.85 31.81c-6.35 4.6-14.93 4.6-21.27 0l-43.85-31.81c-4.98-3.61-9.68-7.53-14.08-11.7 5.85.7 11.82 1.06 17.87 1.06 79.06 0 143.15-61.32 143.15-136.95V61.87c5.32.21 10.87.34 16.68.37 1.66 0 3 1.34 3 2.99z"
        data-original="#7acaa6"
      ></path>
      <path
        fill="#f6f0f7"
        d="M316.458 151.177h-40.32a2 2 0 01-2-2v-40.32a2 2 0 00-2-2h-32.275a2 2 0 00-2 2v40.32a2 2 0 01-2 2h-40.32a2 2 0 00-2 2v32.275a2 2 0 002 2h40.32a2 2 0 012 2v40.32a2 2 0 002 2h32.275a2 2 0 002-2v-40.32a2 2 0 012-2h40.32a2 2 0 002-2v-32.275a2 2 0 00-2-2z"
        data-original="#f6f0f7"
      ></path>
      <path
        fill="#98d5b9"
        d="M9.5 129.85h18.993a2 2 0 002-2v-18.993a2 2 0 012-2H57.26a2 2 0 012 2v18.993a2 2 0 002 2h18.993a2 2 0 012 2v24.768a2 2 0 01-2 2H61.261a2 2 0 00-2 2v18.993a2 2 0 01-2 2H32.493a2 2 0 01-2-2v-18.993a2 2 0 00-2-2H9.5a2 2 0 01-2-2V131.85a2 2 0 012-2zm493 0h-18.993a2 2 0 01-2-2v-18.993a2 2 0 00-2-2h-24.768a2 2 0 00-2 2v18.993a2 2 0 01-2 2h-18.993a2 2 0 00-2 2v24.768a2 2 0 002 2h18.993a2 2 0 012 2v18.993a2 2 0 002 2h24.768a2 2 0 002-2v-18.993a2 2 0 012-2H502.5a2 2 0 002-2V131.85a2 2 0 00-2-2z"
        data-original="#98d5b9"
      ></path>
      <path
        fill="#7acaa6"
        d="M116.685 30.45h-12.5v-12.5c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v12.5h-12.5c-4.143 0-7.5 3.358-7.5 7.5s3.357 7.5 7.5 7.5h12.5v12.5c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-12.5h12.5a7.5 7.5 0 000-15zm318.63 0h-12.5v-12.5c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v12.5h-12.5c-4.143 0-7.5 3.358-7.5 7.5s3.357 7.5 7.5 7.5h12.5v12.5c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-12.5h12.5c4.143 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5z"
        data-original="#7acaa6"
      ></path>
    </svg>
  );
}

export default Reactions;